<div *ngIf="loading" class="loading">
  <mat-spinner></mat-spinner>
</div>
<div class="operations">
  <div class="table">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <table
      [dataSource]="dataSource"
      mat-table
      class="table__container"
      matSort
      matSortDisableClear
    >
      <ng-container *ngFor="let column of tableColumns;" matColumnDef="{{column.columnDef}}">
        <th mat-header-cell *matHeaderCellDef class="table__cell-title"
            [mat-sort-header]="column.sortDef??column.columnDef"
            [disabled]="columnsWithoutSort.includes(column.columnDef)">
          {{column.header}}
        </th>
        <td mat-cell *matCellDef="let element" class="table__cell">
          {{column.cell(element)}}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        [routerLink]="'/analytic/operations/report-details/' + row.keycloakId"
      ></tr>
    </table>
  </div>
  <mat-paginator
    #paginator
    [pageSize]='20'
    [pageSizeOptions]="[15, 20, 50]"
    showFirstLastButtons
  ></mat-paginator>
</div>
